/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Evaluation result for a specific rubric criterion.
 */
export interface LlmCriteriaEvaluation {
  /** Name of the rubric criterion evaluated. */
  name: string;
  /** True if the student has sufficiently met this criterion. */
  met: boolean;
}
